export default {
  'address': 'Διεύθυνση',
  'auth': {
    'connected': 'Συνδεδεμένος',
    'connectionSettings': 'ρυθμίσεις σύνδεσης',
    'connectionSettingsSubtitle': 'Ορίστε τις παραμέτρους του application server',
    'dbName': 'Database name',
    'deviceName': 'Όνομα συσκευής',
    'email': 'E-mail',
    'expiredSession': 'Η συνεδρία έληξε. Παρακαλώ συνδεθείτε ξανά.',
    'forgotPassword': 'Ξέχασα τον κωδικό μου',
    'forgotPasswordAction': 'Αποστολή',
    'forgotPasswordSubtitle':
      'Ο κωδικός πρόσβασης θα επαναφερθεί. Θα σας στείλουμε ένα email επιβεβαίωσης.',
    'forgotPasswordTitle': 'Ξέχασες τον κωδικό σου;',
    'language': 'γλώσσα',
    'languageSelect': 'Επιλέξτε γλώσσα',
    'login': 'Σύνδεση',
    'logoutPrompt': 'Είστε σίγουροι ότι θέλετε να αποσυνδεθείτε;',
    'notConnected': 'Δεν είστε συνδεδεμένοι',
    'notConnectedSubtitle': 'Ρυθμίστε τη σύνδεσή σας',
    'offline': 'μη συνδεδεμένος',
    'offlineLogin': 'Σύνδεση offline',
    'online': 'συνδεδεμένος',
    'password': 'Κωδικός πρόσβασης',
    'rememberMe': 'Θυμήσου με',
    'resetPassword': 'Επαναφορά Κωδικού',
    'saveSettings': 'αποθήκευση',
    'serverIP': 'Server IP',
    'serverPort': 'Server Port',
    'subtitle': 'Ας πιάσουμε δουλειά',
    'username': 'Όνομα χρήστη',
    'userType': 'Ρόλος Χρήστη',
    'version': 'Εκδοση',
    'welcome': 'Καλώς όρισες',
  },
  'baseObject': {
    'actions': 'Ενέργειες',
    'boid': 'BOID',
    'code': 'Κωδικός',
    'createUser': 'Δημιουργήθηκε από',
    'createdDate': 'Ημ/νία Δημιουργίας',
    'deleted': 'Διαγραμμένο',
    'exportDate': 'Ημερομηνία εξαγωγής',
    'isActive': 'Ενεργό',
    'isFromManager': 'Από Manager',
    'lastUpdate': 'Τελευταία Ενημέρωση',
    'name': 'Όνομα',
    'rowStatus': 'Row Status',
    'sequence': 'Σειρά',
    'updateUser': 'Ενημερώθηκε από',
  },
  'branch': 'Παράρτημα',
  'city': 'Πόλη',
  'common': {
    'actions': {
      'add': 'Προσθήκη',
      'addAll': 'Προσθήκη Όλων',
      'addFiltered': 'Προσθήκη Φιλτραρισμένων',
      'addNew': 'Νέα Εγγραφή',
      'allowed': 'Επιτρέπεται',
      'cancel': 'Ακύρωση',
      'clear': 'Επαναφορά',
      'clone': 'Αντιγραφή',
      'close': 'Κλείσιμο',
      'closepopup': 'Κλείσιμο παραθύρου',
      'confirm': 'Επιβεβαίωση',
      'create': 'Δημιουργία',
      'defineSet': 'Δημιουργία Set',
      'delete': 'Διαγραφή',
      'deleteAll': 'Διαγραφή Όλων',
      'edit': 'Επεξεργασία',
      'moveTo': 'Μετακίνηση',
      'no': 'Όχι',
      'notAllowed': 'Δεν επιτρέπεται',
      'restore': 'Επαναφορά',
      'save': 'Αποθήκευση',
      'search': 'Αναζήτηση',
      'select': 'Επιλογή',
      'showLess': 'Λιγότερα',
      'showMore': 'Περισσότερα',
      'view': 'Προεπισκόπηση',
      'yes': 'Ναι',
    },
    'definedSets': 'Πακέτα Επιλεγμένων Ειδών',
    'defineSets': 'Δημιουργία Πακέτων',
    'defineSetsMustAtLeast':
      'Ορίστε τα σετ και τα είδη/ομάδες που είναι "Υποχρεωτικά" ή "τουλάχιστον να υπάρχουν"',
    'invalid': 'Άκυρο',
    'materialsGroups': 'Είδη/Ομάδες',
    'must': 'Υποχρεωτικό',
    'next': 'Επόμενο',
    'or': 'ή',
    'other': 'Λοιπά',
    'previous': 'Προηγούμενο',
    'setSameAs': 'Σετ: Ίδιο με',
    'table': {
      'applyFilters': 'Εφαρμογή Φίλτρων',
      'resetFilters': 'Εκκαθάριση Ολων',
      'selected': 'Επιλεγμένα',
    },
    'tableGroup': 'Σύρετε μια στήλη εδώ για να ομαδοποιήσετε κατά αυτή τη στήλη',
    'toast': {
      'closepopup': 'Κλείσιμο παραθύρου',
      'error': 'Σφάλμα',
      'info': 'Ενημέρωση',
      'success': 'Επιτυχία',
      'warning': 'Προσοχή',
    },
    'tooltip': {
      'cardView': 'Κάρτα',
      'columnOrder': 'Ταξινόμηση στηλών',
      'download': 'Αποθήκευση',
      'enhancedView': 'Λεπτομέρειες',
      'filterMaterialsByGroup': 'Φιλτράρισμα ειδών ανά ομάδα',
      'horizontalLayout': 'Οριζόντια διάταξη',
      'print': 'Εκτύπωση',
      'refresh': 'Ανανέωση',
      'report': 'Report',
      'saveLayout': 'Αποθήκευση layout',
      'sendEmail': 'Αποστολή Email',
      'showFilter': 'Φίλτρα',
      'tableView': 'Πίνακας',
      'verticalLayout': 'Κάθετη διάταξη',
    },
    'totalRecords': 'Συνολικές Εγγραφές',
    'valid': 'Έγκυρο',
  },
  'competitor': {
    'competitorType': 'Τύπος Ανταγωνιστή',
    'profession': 'Επάγγελμα',
    'properties': 'Πληροφορίες',
    'remarks': 'Σχόλια',
    'trader': 'Συναλλασσόμενος',
    'traderAddress': 'Διεύθυνση Συναλλασσομένου',
    'traderCity': 'Πόλη Συναλλασσομένου',
    'traderCode': 'Κωδικός Συναλλασσομένου',
    'traderName': 'Όνομα Συναλλασσομένου',
    'traderTaxNumber': 'ΑΦΜ Συναλλασσομένου',
    'traderZipCode': 'ΤΚ Συναλλασσομένου',
  },
  'competitorMaterials': {
    'competitorMaterial': 'Είδη Ανταγωνιστή',
    'match': 'Δημιουργία ',
    'selectCompetitor': 'Επιλέξτε Ανταγωνιστή',
    'selectMaterial': 'Επιλέξτε είδος',
  },
  'customer': {
    'currentTraderSiteAddress': 'Διεύθυνση υποκαταστήματος',
    'currentTraderSiteTaxCode': 'Φορολογικός κωδ. υποκαταστήματος',
    'defaultDocumentType': 'Προεπιλεγμένος Τύπος Παραστατικού',
    'defaultPaymentType': 'Προεπιλεγμένος Τρόπος Πληρωμών',
    'defaultTraderSite': 'Προεπιλεγμένο Υποκατάστημα',
    'discountPercentage': 'Ποσοστό Έκπτωσης (%)',
    'financialInfo': 'Οικονομικά στοιχεία',
    'minOrder': 'Ελάχιστη Παραγγελία',
    'paymentDays': 'Ημέρες Πληρωμών',
    'plafond': 'Πλαφόν',
    'profession': 'Επάγγελμα',
    'properties': 'Πληροφορίες',
    'ranges': 'Γκάμες',
    'trader': 'Συναλλασσόμενος',
    'traderAddress': 'Διεύθυνση Συναλλασσομένου',
    'traderCity': 'Πόλη Συναλλασσομένου',
    'traderCode': 'Κωδικός Συναλλασσομένου',
    'traderJob': 'Επάγγελμα Συναλλασσομένου',
    'traderName': 'Όνομα Συναλλασσομένου',
    'traderSiteAddress': 'Διεύθυνση Υποκαταστήματος',
    'traderSiteCity': 'Πόλη Υποκαταστήματος',
    'traderSiteCode': 'Κωδικός Υποκαταστήματος',
    'traderSiteIsHQ': 'Είναι Κεντρικό Υποκατάστημα',
    'traderSiteName': 'Όνομα Υποκαταστήματος',
    'traderSites': 'Υποκαταστήματα',
    'traderSiteZipCode': 'ΤΚ Υποκαταστήματος',
    'traderTaxNumber': 'ΑΦΜ Συναλλασσομένου',
    'traderTitle': 'Τίτλος',
    'traderZipCode': 'ΤΚ Συναλλασσομένου',
  },
  'date': {
    'date': 'ημερομηνία',
    'days': {
      '0': 'Κυριακή',
      '1': 'Δευτέρα',
      '2': 'Τρίτη',
      '3': 'Τετάρτη',
      '4': 'Πέμπτη',
      '5': 'Παρασκευή',
      '6': 'Σάββατο',
    },
    'invalidDate': 'Μη έγκυρη ημερομηνία',
    'months': {
      '0': 'Ιανουάριος',
      '1': 'Φεβρουάριος',
      '2': 'Μάρτιος',
      '3': 'Απρίλιος',
      '4': 'Μάιος',
      '5': 'Ιούνιος',
      '6': 'Ιούλιος',
      '7': 'Αύγουστος',
      '8': 'Σεπτέμβριος',
      '9': 'Οκτώβριος',
      '10': 'Νοέμβριος',
      '11': 'Δεκέμβριος',
    },
    'now': 'τώρα',
    'time': 'ώρα',
    'today': 'σήμερα',
  },
  'device': {
    'device': 'Συσκευή',
    'lastLogin': 'Τελευταία Σύνδεση',
    'loadItemLines': 'Φόρτωση γραμμών',
    'remarks': 'Σχόλια',
  },
  'device-configuration': {
    'companySite': 'Εταιρικό Κατάστημα',
    'defaultUser': 'Προεπιλεγμένος χρήστης',
    'documentSeries': 'Σειρά Παραστατικού',
    'documentType': 'Τύπος εγγράφου',
    'functionality': 'Λειτουργικότητα',
  },
  'discountMatrix': {
    'discount': 'Έκπτωση %',
    'discountType': 'Είδος Έκπτωσης',
    'materialGroup': 'Κατηγορία είδους',
    'traderSite': 'Υποκατάστημα',
    'traderSiteGroup': 'Ομάδα υποκαταστημάτων',
    'value': 'Τιμή €',
  },
  'distribution-channel': {
    'company': 'Εταιρία',
    'exvan': 'Exvan',
    'isDefault': 'Προεπιλογή',
    'logistics': 'Logistics',
    'orders': 'Παραγγελίες',
    'uniqueTradersPerRoute': 'Μοναδικοί Πελάτες Ανά Δρομολόγιο',
  },
  'documentDetails': {
    'discount1': 'Έκπτωση 1',
    'discount2': 'Έκπτωση 2',
    'discount3': 'Έκπτωση 3',
    'discount4': 'Έκπτωση 4',
    'discount5': 'Έκπτωση 5',
    'discount6': 'Έκπτωση 6',
    'grossValue': 'Μικτή Αξία',
    'materialCode': 'Κωδικός Υλικού',
    'materialName': 'Όνομα Υλικού',
    'netValue': 'Καθαρή Αξία',
    'quantity1': 'Ποσότητα 1',
    'quantity2': 'Ποσότητα 2',
    'quantity3': 'Ποσότητα 3',
    'rowId': 'ID Γραμμής',
    'totalDiscount': 'Συνολική Έκπτωση',
    'unit1': 'Μονάδα 1',
    'unit2': 'Μονάδα 2',
    'unit3': 'Μονάδα 3',
    'unitPrice': 'Τιμή Μονάδας',
    'vatPercent': 'ΦΠΑ %',
    'vatValue': 'Αξία ΦΠΑ',
  },
  'document-type': {
    'allowDynamicRange': 'Επιτρέπονται Δυναμικές Γκάμες',
    'allowEditClosedDocuments': 'Επεξεργασία Κλειστών Παραστατικών',
    'allowHeaderDiscounts': 'Επιτρέπονται Εκπτώσεις Επιπέδου Παραστατικού',
    'allowManualPrices': 'Επιτρέπονται Μη Αυτόματες Τιμές',
    'allowZeroQty': 'Επιτρέπεται Μηδενική Ποσότητα',
    'allowZeroValues': 'Επιτρέπονται Μηδενικές Τιμές',
    'caption': 'Τίτλος',
    'columnDefinitions': 'Ορισμός Στηλών',
    'common': 'Κοινά',
    'company': 'Εταιρία',
    'configurationProperties': 'Παραμετροποίηση',
    'daysToDelivery': 'Παράδοση Μετά Από Ημέρες',
    'defaultDeliveryType': 'Προεπιλεγμένος Τύπος Παράδοσης',
    'defaultDocumentStatus': 'Προεπιλεγμένη Κατάσταση Εγγράφου',
    'defaultPaymentType': 'Προεπιλεγμένος Τρόπος Πληρωμών',
    'defaultTrader': 'Προεπιλεγμένος Συναλλασσόμενος',
    'defaultWarehouse': 'Προεπιλεγμένη Αποθήκη',
    'description': 'Περιγραφή',
    'division': 'Τμήμα',
    'documentSeries': 'Σειρά Παραστατικού',
    'fields': 'Πεδία',
    'maxDetailQty': 'Μέγιστη Ποσότητα Γραμμής',
    'maxDetailUnitPrice': 'Μέγιστη Τιμή Μονάδας Γραμμής',
    'mergedSameDocumentLines': 'Συγχωνευμένες Ίδιες Γραμμές Εγγράφου',
    'order': 'Σειρά',
    'parentDocumentType': 'Γονικός Τύπος Παραστατικού',
    'previewColumns': 'Προεπισκόπηση Στηλών',
    'previewDescription':
      'Αυτή η προεπισκόπηση δείχνει πώς θα εμφανίζονται οι στήλες στον πίνακα λεπτομερειών παραστατικού πωλήσεων με βάση τη διαμόρφωσή σας.',
    'previewNote': 'Πληροφορίες Προεπισκόπησης:',
    'previewNoteColumns': 'Οι στήλες εμφανίζονται σύμφωνα με τη διαμόρφωση JSON',
    'previewNoteWidth': 'Τα πλάτη στηλών ταιριάζουν με τις καθορισμένες τιμές',
    'previewNoteOrder': 'Η σειρά στηλών ακολουθεί την ιδιότητα OrderNumber',
    'properties': 'Πληροφορίες',
    'relatedDocumentTypes': 'Συσχετιζόμενοι Τύποι Παραστατικών',
    'reportingTemplate': 'Reporting Template',
    'remove': 'Remove',
    'requireDeliveryType': 'Απαιτεί Τύπο Παράδοσης',
    'requirePaymentType': 'Απαιτεί Τρόπο Πληρωμής',
    'requireWarehouse': 'Απαιτεί Αποθήκη',
    'sequenceFormat': 'Μορφή Αρίθμησης',
    'specific': 'Συγκεκριμένα',
    'supportLoyalty': 'Υποστήριξη Loyalty',
    'syncWithMyData': 'Διαβίβαση στο myData',
    'takeDigitalSignature': 'Ψηφιακή Υπογραφή',
    'totalMeasurementUnits': 'Συνολικές Μονάδες Μέτρησης',
    'trader': 'Συναλλασσόμενος',
    'usePaymentTypes': 'Χρήση Τρόπων Πληρωμής',
    'width': 'Πλάτος',
  },
  'groups': {
    'accountGroup': 'Account Group',
    'active': 'Ενεργό',
    'addGroup': 'Προσθήκη Ομάδας',
    'addGroupItem': 'Προσθήκη {item}',
    'alterCode': 'Εναλλακτικό κωδικό',
    'description': 'Περιγραφή',
    'groups': 'Ομάδες',
    'maxLevel': 'Μεγ. Επίπεδο',
    'name': 'Όνομα',
    'system': 'System',
  },
  'HQ': 'Κεντρικό Υποκατάστημα',
  'imageUpload': 'Σύρετε και αφήστε μια εικόνα εδώ, ή κάντε κλικ για να επιλέξετε',
  'material': {
    'active': 'Ενεργό',
    'alterCode': 'Εναλλακτικός Κωδικός',
    'alterCodeType': 'Τύπος εναλ. κωδικού',
    'alterName': 'Εναλλακτική Ονομασία',
    'allowManualPrice': 'Επιτρέπεται αλλαγή τιμής',
    'allowZeroValue': 'Επιτρέπεται μηδενική τιμή',
    'boid': 'Boid',
    'code': 'Κωδικός',
    'color': 'Χρώμα',
    'company': 'Εταιρία',
    'companyAlterCodes': 'Εναλλακτικοί κωδικοί εταιρίας',
    'competitor': 'Ανταγωνιστης',
    'competitorAlterCodes': 'Εναλλακτικοί κωδικοί ανταγωνιστή',
    'createUser': 'Created By',
    'createdDate': 'Created Date',
    'default': 'Βασικό',
    'dimension': 'Διάσταση {number}',
    'dimensions': 'Διάστασεις',
    'hasMixInfo': 'Μεικτή πληροφορία',
    'inactive': 'Ανενεργό',
    'isActive': 'Status',
    'isFromManager': 'From Manager',
    'lastUpdate': 'Last Update',
    'lotFinish': 'Τέλος Παρτίδας',
    'lotStart': 'Αρχή Παρτίδας',
    'material': 'Προϊον',
    'materialDC': 'Κανάλι Διανομής Προϊόντος',
    'materialType': 'Τύπος',
    'materials': 'Προϊόντα',
    'measurementUnit': 'Μοναδα Μέτρησης',
    'minSalesQuantity': 'Ελάχιστη Πώληση',
    'mwAccountGroup': 'Account Group',
    'name': 'Όνομα',
    'quantityTotalizer': 'Quantity Totalizer',
    'relationFactor': 'Συντελεστής Σχέσης',
    'remarks': 'Σχόλια',
    'rowStatus': 'Row Status',
    'securityStock': 'Απόθεμα',
    'sequence': 'Σειρά',
    'size': 'Μεγεθος',
    'smallCode': 'Συντ. Κωδικός',
    'smallName': 'Συντ. Όνομα',
    'style': 'Style',
    'unit1': '1η Μονάδα',
    'unit2': '2η Μονάδα',
    'unit3': '3η Μονάδα',
    'updateUser': 'Updated By',
    'vatCategory': 'Κατηγορία ΦΠΑ %',
  },
  'messages': {
    'continueEdit': 'Συνέχεια Επεξεργασίας',
    'dismissChanges': 'Απόρριψη Αλλαγών',
    'errors': {
      'aadeError': 'Σφάλμα κατά τη διαδικασία αποστολής στο AADE.',
      'access': 'Δεν έχετε προσβαση σε αυτή τη σελίδα',
      'cannotDelete': 'Οι εγγραφές δεν μπορούν να διαγραφούν',
      'columnDefinitionsJsonError': 'Δεν είναι δυνατή η προεπισκόπηση',
      'customerReferencedByTraderSite':
        'Αποτυχία διαγραφής πελάτη καθώς συσχετίζεται με υποκατάστημα.',
      'dateError': 'Σφαλμα Επιλογής Ημ/νιας',
      'duplicateRemoteCode': 'Αυτός ο απομακρυσμένος κωδικός έχει ήδη οριστεί στον αντιπρόσωπο',
      'emptyNode': 'Can not create empty node.',
      'failedToCloneQuestionnaire': 'Αποτυχία αντιγραφής ερωτηματολογίου.',
      'failedToLoadQuestionnaire': 'Αποτυχία φόρτωσης δεδομένων ερωτηματολογίου.',
      'fileTypeNotAllowed':
        'Αυτός ο τύπος αρχείου δεν υποστηρίζεται. Παρακαλώ ανεβάστε μια εικόνα.',
      'greaterThan0': 'Μεγαλύτερο του 0',
      'integer': 'Παρακαλώ εισάγετε έναν ακέραιο αριθμό.',
      'invalidDateFormat': 'Μη έγκυρη ημερομηνία',
      'invalidEmail': 'Μη έγκυρη διεύθυνση email',
      'invalidNodeMove': 'Ένας κόμβος δεν μπορεί να τοποθετηθεί μέσα στην ιεραρχία του.',
      'invalidValue': 'Μη έγκυρη τιμή',
      'largeFile': 'Αυτό το αρχείο υπερβαίνει το όριο του 1MB',
      'materialNotInActiveCatalog': 'Το προϊόν δεν υπάρχει σε ενεργό τιμοκατάλογο',
      'maxGraterThanMin': 'Η μέγιστη τιμή πρέπει να είναι μεγαλύτερη από την ελάχιστη τιμή',
      'maxValue': 'Μέγιστη τιμή',
      'minSmallerThanMax': 'Η ελάχιστη τιμή πρέπει να είναι μικρότερη από τη μέγιστη τιμή',
      'minValue': 'Ελάχιστη τιμή',
      'missingFinancialInfo': 'Δεν βρέθηκαν οικονομικά στοιχεία.',
      'missingMaterialRecentTransactions': 'Δεν βρέθηκαν συναλλαγές',
      'noDefaultReportingTemplate': 'Δεν έχει οριστεί Reporting Template',
      'nonNegative': 'Η τιμή πρέπει να είναι τουλάχιστον 0',
      'required': 'Απαραίτητο',
      'requiredField': 'Το πεδίο είναι απαραίτητο',
      'salesDocumentHeaderIncomplete':
        'Παρακαλώ συμπληρώστε τα υποχρεωτικά πεδία προκειμένου να καταχωρήσετε γραμμές στο παραστατικό.',
      'selectTraderSiteFirst': 'Παρακαλώ επιλέξτε Υποκατάστημα και προσπαθήστε ξανά',
      'sequenceMustBeUnique': 'Η σειρά πρέπει να είναι μοναδική',
      'somethingWentWrong': 'Κάτι πήγε στραβά',
      'totalMeasurementUnitsRange': 'Οι συνολικές μονάδες μέτρησης πρέπει να είναι έως 3',
    },
    'info': {
      'addDataTableText': 'Προσθέστε μια νέα εγγραφή',
      'ctrlClickToAddItems': 'Ctrl + click για προσθήκη στοιχείων',
      'deleteAdded':
        'Είστε σίγουροι ότι θέλετε να διαγράψετε το {item}? Τα νέα, μη αποθηκευμένα στοιχεία δεν μπορούν να ανακτηθούν αν διαγραφούν.',
      'deleteCascade':
        'Είστε σίγουροι ότι θέλετε να διαγράψετε τις επιλεγμένες εγγραφές; Αυτό ίσως διαγράψει και εγγραφές που εξαρτώνται από αυτές.',
      'deleteModified':
        'Είστε σίγουροι ότι θέλετε να διαγράψετε το {item}? Η επεξεργασία που έχετε κάνει σε αυτό το στοιχείο θα χαθεί.',
      'deleteNode':
        'Είστε σίγουροι ότι θέλετε να διαγράψετε την επιλεγμένη εγγραφή; Αυτό ίσως διαγράψει και εγγραφές που εξαρτώνται από αυτή.',
      'deleteRecords': 'Είστε σίγουροι ότι θέλετε να διαγράψετε τις επιλεγμένες εγγραφές;',
      'deleteSingle': 'Είστε σίγουροι ότι θέλετε να διαγράψετε το {item};',
      'deleteAllItems': 'Είστε σίγουροι ότι θέλετε να διαγράψετε όλα τα στοιχεία;',
      'emptyTableText': 'Δεν υπάρχουν δεδομένα',
      'restoreSingle': 'Είστε σίγουροι ότι θέλετε να επαναφέρετε το {item};',
      'selectedItemsCannotBeDeleted': 'Τα επιλεγμένα στοιχεία δεν μπορούν να διαγραφούν.',
      'selectedItemsCannotBeEdited': 'Τα επιλεγμένα στοιχεία δεν μπορούν να ενημερωθούν.',
    },
    'noResultsFor': "Δεν βρέθηκαν αποτελέσματα για '{query}'",
    'noResultsText': 'Δεν βρέθηκαν αποτελέσματα',
    'noUpdateDeleted': 'Δεν μπορείτε να ενημερώσετε σε διαγραμμενο στοιχειο',
    'saveLineChangesPrompt':
      'Βεβαιωθείτε ότι θα αποθηκεύσετε τις αλλαγές της γραμμής προτού αποθηκεύσετε το παραστατικό',
    'success': {
      'deletedSuccessfully': 'Διαγράφηκε επιτυχώς.',
      'resetPassword': 'Έγινε επαναφορά κωδικού πρόσβασης.',
      'successfullyDeleted': 'Επιτυχής διαγραφή.',
    },
    'unsavedChanges':
      'Έχετε μη αποθηκευμένες αλλαγές. Θέλετε να συνεχίσετε την επεξεργασία ή να απορρίψετε αυτές τις αλλαγές;',
  },
  'missedVisitReasons': {
    'dueToPlan': 'Λόγω πλάνου',
    'dueToSalesperson': 'Λόγω πωλητή',
    'dueToTraderSite': 'Λόγω καταστήματος ',
    'missedVisitReason': 'αιτίας μη επίσκεψης',
  },
  'myDataDocuments': {
    'division': 'Τμήμα',
    'documentNumber': 'Αριθμός',
    'documentSeries': 'Σειρά',
    'documentType': 'Τύπος',
    'errorDetails': 'Λεπτομέρειες Σφάλματος',
    'filters': {
      'byDocumentSeries': 'Κατά Σειρά Παραστατικού',
      'byDocumentType': 'Κατά Τύπο Παραστατικού',
      'byDivision': 'Κατά Τμήμα',
      'bySyncStatus': 'Ανά Κατάσταση Συγχρονισμού',
      'dateFrom': 'Ημ/νία Από',
      'dateTo': 'Ημ/νία Έως',
      'syncFailed': 'Αποτυχία',
      'syncSuccess': 'Επιτυχής',
      'syncUnsynced': 'Μη Συγχρονισμένο',
    },
    'myDataMark': 'MyData Mark',
    'myDataQrCode': 'MyData QR Code',
    'myDataUuid': 'MyData UUID',
    'noErrorMessage': 'Δεν υπάρχει διαθέσιμο μήνυμα σφάλματος',
    'propertiesDetails': 'Ιδιότητες MyData',
    'syncFailed': 'Απέτυχε',
    'syncStatus': 'Κατάσταση',
    'syncSuccess': 'Διαβιβάστηκε',
    'syncUnsynced': 'Μη Συγχρονισμένο',
    'title': 'Παραστατικά myData',
    'totalGross': 'Συνολική Αξία',
    'totalQuantity': 'Συνολική Ποσότητα',
    'trader': 'Συναλλασσόμενος',
    'traderSite': 'Υποκατάστημα',
    'uploadSelected': 'Διαβίβαση στο myData',
  },
  'mw-params': {
    'company': 'Εταιρία',
    'remarks': 'Σχόλια',
    'value': 'Τιμή',
  },
  'pages': {
    'alter-code-types': 'Τύποι Εναλλακτικών Κωδικών',
    'alter-codes': 'Εναλλακτικοί Κωδικοί',
    'app-preferences': 'Προτιμήσεις Εφαρμογής',
    'assortment-details': 'Διαχείριση assortment',
    'assortments-management': 'Διαχείριση assortment',
    'competitor-materials': 'Προϊοντα ανταγωνισμού ',
    'competitor-materials-wizard': 'Προϊοντα ανταγωνισμού',
    'competitor-types': 'Τύποι Ανταγωνιστών',
    'competitors': 'Ανταγωνιστές',
    'competitors-preview': 'Ανταγωνιστές',
    'customers': 'Πελάτες',
    'customers-preview': 'Πελάτες',
    'dashboard': 'Αρχική',
    'delivery-types': 'Τύπος Παράδοσης',
    'device-details': 'Συσκευές',
    'devices': 'Συσκευές',
    'distribution-channels': 'Κανάλια Παραδόσης',
    'distribution-channels-details': 'Κανάλια Παραδόσης',
    'divisions': 'Τμήματα',
    'document-series': 'Σειρά Παραστατικού',
    'document-series-details': 'Σειρά Παραστατικού - Λεπτομέρειες',
    'document-statuses': 'Καταστάσεις Εγγράφων',
    'document-types': 'Τύποι Παραστατικών',
    'document-types-details': 'Τύποι Παραστατικών',
    'documents-management': 'Διαχείριση Εγγράφων',
    'documents-management-details': 'Διαχείριση Εγγράφων - Λεπτομέρειες',
    'dynamic-ranges': 'Δυναμικές Γκάμες',
    'grouping': 'Ομάδες',
    'installation': 'Εγκατάσταση',
    'materials': 'Είδη',
    'materials-management': 'Διαχείριση Ειδών',
    'materials-management-preview': 'Διαχείριση Ειδών',
    'missed-visits-reasons': 'Αιτίες Μη Επίσκεψης',
    'myAccount': 'Ο Λογαριασμός μου',
    'mydata': 'Παραστατικά myData',
    'payment-types': 'Τρόποι Πληρωμής',
    'price-catalog-details': 'Λεπτομέρειες τιμοκαταλόγου',
    'price-catalogs': 'Τιμοκατάλογοι',
    'price-collection-last-visit-values': 'Συλλογή Τιμών - Τιμές Τελευταίας Επίσκεψης ',
    'price-policies': 'Τιμολογιακές Πολιτικές',
    'price-policies-matrix-details': 'Τιμολογιακή Πολιτική',
    'qst-actions': 'Ενέργειες',
    'questionnaires-management': 'Διαχείριση Ερωτηματολογίων',
    'questionnaires-management-details': 'Διαχείριση Ερωτηματολογίων - Λεπτομέρειες',
    'questionnaires-report': 'Απαντήσεις Ανά Επίσκεψη',
    'questionnaires-report-details': 'Απαντήσεις Επίσκεψης',
    'questions-details': 'Λεπτομέρειες ερωτήσεων',
    'ranges-details': 'Λεπτομέρειες Στατικής Γκάμας',
    'ranges-management': 'Στατικές Γκάμες',
    'report-pricing': 'Αναφορές Τιμοκαταλόγων',
    'reporting': 'Reporting',
    'reporting-designer': 'Reporting Designer',
    'representatives': 'Διαχείριση αντιπροσώπων',
    'representatives-details': 'Στοιχεία Αντιπροσώπου',
    'representatives-transactions': 'Συναλλαγές Αντιπροσώπων',
    'representatives-transactions-details': 'Λεπτομέρειες Συναλλαγής',
    'role-details': 'Λεπτομέρειες Ρόλου',
    'roles': 'Διαχείριση Ρόλων',
    'route-definitions': 'Ορισμοί Δρομολογίων',
    'route-details': 'Καταστήματα Δρομολογίου',
    'route-week-plan': 'Εβδομαδιαίο Πλάνο Δρομολογίου',
    'routes-management': 'Διαχείριση Δρομολογίων',
    'sales-areas': 'Περιοχές πωλήσεων',
    'sales-documents': 'Παραστατικά',
    'sales-documents-details': 'Λεπτομέρειες Παραστατικών',
    'salespersons-hierarchy': 'Κατάταξη πωλητών',
    'salespersons-management': 'Διαχείριση πωλητών',
    'salespersons-management-details': 'Διαχείριση πωλητή',
    'salespersons-types': 'Τύποι πωλητών',
    'settings': 'Ρυθμίσεις',
    'trader-sites': 'Υποκαταστήματα',
    'trader-sites-preview': 'Υποκαταστήματα',
    'traders': 'Συναλλασσόμενοι',
    'traders-preview': 'Συναλλασσόμενος',
    'user-defined-reports': 'Reports Χρήστη',
    'user-details': 'Λεπτομέρειες χρήστη',
    'users': 'Διαχείριση Χρηστών',
    'validation-logger': 'Αναφορές Σφαλμάτων',
    'vat-categories': 'Κατηγορίες ΦΠΑ',
    'vat-factors': 'Συντελεστές ΦΠΑ',
    'vat-levels': 'Επίπεδο ΦΠΑ',
    'visit-plans': 'Πλάνα Επισκέψεων',
    'warehouses-management': 'Διαχείριση αποθηκών',
  },
  'price-collection-document': {
    'documentNumber': 'Αριθμός Κεφαλίδας Εγγράφου',
    'isCompetitorPriceCollection': 'Αφορά Τιμοληψία Ανταγωνισμού',
    'salesPerson': 'Πωλητής',
    'salesPersonCode': 'κωδ. Πωλητή',
    'sendDate': 'Ημερομηνία Αποστολής',
    'traderSite': 'Συναλλασσόμενος',
  },
  'price-catalog': {
    'addAllCustomers':
      'Θα προστεθούν όλοι οι πελάτες και τυχόν αλλαγές στη φόρμα θα αποθηκευτούν. Είστε βέβαιοι ότι θέλετε να συνεχίσετε;',
    'addAllModalSubText':
      'Η φόρμα θα αποθηκευτεί αυτόματα. Είστε βέβαιοι ότι θέλετε να συνεχίσετε;',
    'addAllModalText': 'Πρόκειται να προσθέσετε όλα τα είδη με τις παρακάτω τιμές.',
    'catalogsList': 'Λίστα Τιμοκαταλόγων',
    'endDate': 'Ημερομηνία λήξης',
    'includeVat': 'Συμπεριλαμβάνεται ΦΠΑ',
    'permitDiscount': 'Δυνατότητα έκπτωσης',
    'startDate': 'Ημερομηνία έναρξης',
  },
  'pricing': {
    'pricingPolicy': 'Τιμολογιακή πολιτική',
    'pricingType': 'Pricing type',
  },
  'pricing-catalogs': {
    'addNewCatalogPolicyTitle': 'Προσθήκη νέας πολιτικής τιμοκαταλόγων',
    'addNewCatalogTitle': 'Προσθήκη τιμοκαταλόγων',
    'catalog': 'Τιμοκατάλογος',
    'categories': 'Κατηγορίες',
    'company': 'Εταιρία',
    'discountMatrix': 'Εκπτωτικοί Τιμοκατάλογοι',
    'editCatalogPolicyTitle': 'Επεξεργασία πολιτικής τιμοκαταλόγων',
    'maxDiscount': 'Μεγ. Έκπτωση %',
    'maxDiscountValue': 'Μεγ. τιμή έκπτωσης',
    'orderPolicies': 'Τιμολογιακές Πολιτικές',
    'price': 'Τιμή €',
    'priceCatalogs': 'Τιμοκατάλογοι',
    'previousPrice': 'Προηγούμενη τιμή €',
    'selectCategory': 'Επιλογή κατηγορίας',
    'status': 'Κατάσταση',
  },
  'prototypes': {
    'acceptedValue': 'Αποδεκτή Τιμή',
    'condition': 'Συνθήκη',
    'perfectValue': 'Ιδανικη Τιμή',
    'products': 'Προϊόντα',
    'recommendedValue': 'Προτεινόμενη Τιμή',
  },
  'qst-actions': {
    'actionDetail': 'Λεπτομέρειες',
    'addAction': 'Προσθήκη Ενέργειας',
    'addActionDetail': 'Προσθήκη',
    'description': 'Περιγραφή',
    'editAction': 'Επεξεργασία Ενέργειας',
    'editActionDetail': 'Επεξεργασία',
    'qstActionUpdated': 'Ενημερώθηκε',
    'settled': 'Settled',
  },
  'qst-transaction-master': {
    'userName': 'Username',
    'visitDateFrom': 'Ημ/νία Επίσκεψης Από',
    'visitDateTo': 'Ημ/νία Επίσκεψης Έως',
  },
  'question': {
    'answerValue': 'Τιμή Απάντησης',
    'dataType': 'Τύπος δεδομένων',
    'halo': 'Μέγιστο όριο τιμών',
    'image': 'Εικόνα',
    'lalo': 'Ελάχιστο όριο τιμών',
    'lastVisitData': 'Δεδομένα τελευταίας επίσκεψης',
    'listValues': 'Λίστα τιμών',
    'nullValues': 'Κενές τιμές',
    'preview': 'Προεπισκόπηση Ερωτηματολογίου',
    'sort': 'Ταξινόμηση',
  },
  'questionnaire': {
    'action': 'Ενέργεια',
    'assortment': 'Ταξινόμηση',
    'bindingType': 'Binding Type',
    'deleteQuestionnaires':
      'Είστε βέβαιοι για την διαγραφή του ερωτηματολογίου; Θα διαγραφούν και όλες οι ερωτήσεις του.',
    'deleteQuestionnaireWarning': 'Θα διαγραφούν και όλες οι ερωτήσεις του.',
    'description': 'Περιγραφή',
    'effectiveFrom': 'Σε ισχύ από',
    'effectiveUpTo': 'Σε ισχύ έως και',
    'groupItem': 'Ομάδα ειδών',
    'isStandards': 'Standards',
    'listColumns': 'Αρ. Στηλών',
    'partialCloneError':
      'Το ερωτηματολόγιο αντιγράφηκε αλλά κάποιες ερωτήσεις ή πρότυπα δεν αποθηκεύτηκαν.',
    'preview': 'Προεπισκόπηση Ερωτηματολογίου',
    'prototypes': 'Πρότυπα',
    'questionnaireClonedSuccessfully': 'Το ερωτηματολόγιο αντιγράφηκε επιτυχώς!',
    'questionnaireTitle': 'Ερωτηματολόγιο',
    'questionnaireType': 'Τύπος',
    'questions': 'Ερωτήσεις',
    'questionsApplication': 'Εφαρμογή ερωτήσεων',
    'questionTitle': 'Ερώτηση',
    'saveBeforeNavigating':
      'Παρακαλώ αποθηκεύστε πρώτα το ερωτηματολόγιο για να μην χάσετε τις αλλαγές σας.',
    'title': 'Τίτλος',
    'traderSiteGroup': 'Ομάδα υποκαταστημάτων',
  },
  'ranges': {
    'alterCodeCode': 'Εναλλακτικός Κωδικός',
    'alterCodeName': 'Ενναλακτικό Όνομα',
    'code': 'Κωδικός γκάμας',
    'customerCode': 'Κωδικός Πελάτη',
    'editDynamicRange': 'Επεξεργασία Στοιχείου Δυναμικής Γκάμας',
    'hasDynamicRange': 'Δυναμική γκάμα',
    'lastDocumentDate': 'Ημ/νία Παραστατικού',
    'materialCode': 'Κωδικός Είδους',
    'materialName': 'Όνομα Είδους',
    'name': 'Όνομα γκάμας',
    'quantity': 'Ποσότητα',
    'traderName': 'Όνομα Πελάτη',
    'traderSite': 'Συναλλασσόμενος',
    'traderSiteCode': 'Κωδικός Συναλλασσομένου',
    'traderSiteName': 'Όνομα Διεύθυνσης Υποκαταστήματος',
  },
  'reporting': {
    'datasourceScript': 'Datasource Script',
    'documentType': 'Τύπος Παραστατικών',
    'functionality': 'Λειτουργικότητα',
    'multipleParams':
      'Βρέθηκαν πολλαπλές διαφορετικές παράμετροι $$. Παρακαλώ χρησιμοποιήστε ακριβώς μία παράμετρο $$.',
    'template': 'Template',
    'unsafeSql': 'Μη ασφαλής SQL',
  },
  'representative': {
    'addImport': 'Νέα Εισαγωγή',
    'allowChange': 'Επιτρέπει Αλλαγές',
    'allowUpdate': 'Επιτρέπει Ενημέρωση',
    'approvalUser': 'Εγκρίθηκε Από',
    'company': 'Εταιρία',
    'companyDocumentType': 'Τύπος Παραστατικού Εταιρίας',
    'companyInfo': 'Εταιρία',
    'companyPaymentType': 'Τρόπος Πληρωμής Εταιρίας',
    'companySite': 'Υποκατάστημα Εταιρίας',
    'companyWarehouse': 'Αποθήκη Εταιρείας',
    'confirmSetAsDefaultForAllCustomers':
      'Είστε βέβαιοι ότι θέλετε να ορίσετε αυτόν τον τύπο παραστατικού ως προεπιλογή για όλους τους πελάτες;',
    'customer': 'Πελάτης',
    'customerCode': 'Κωδικός Πελάτη',
    'customerRemotedAddress': 'Απομακρυσμένη Διεύθυνση Πελάτη',
    'customerRemotedCity': 'Απομακρυσμένη Πόλη Πελάτη',
    'customerRemotedCode': 'Απομακρυσμένος Κωδικός Πελάτη',
    'customerRemotedName': 'Απομακρυσμένο Όνομα Πελάτη',
    'customerRemotedTaxCode': 'Απομακρυσμένος ΑΦΜ Πελάτη',
    'customers': 'Πελάτες',
    'customerSiteAddress': 'Διεύθυνση Υποκαταστήματος Πελάτη',
    'customerSiteCity': 'Πόλη Υποκαταστήματος Πελάτη',
    'customerSiteCode': 'Κωδικός Υποκαταστήματος Πελάτη',
    'customerSiteName': 'Όνομα Υποκαταστήματος Πελάτη',
    'defaultDocumentTypeSetSuccessfully':
      'Ο προεπιλεγμένος τύπος παραστατικού ορίστηκε με επιτυχία για όλους τους πελάτες.',
    'dbName': 'Όνομα Βάσης Δεδομένων',
    'dbUsername': 'Χρήστης Βάσης Δεδομένων',
    'dbPassword': 'Κωδικός Βάσης Δεδομένων',
    'document': 'Παραστατικό',
    'documentDescription': 'Περιγραφή Παραστατικού',
    'documentHeaderRowId': 'Document Header Row ID',
    'documentNumber': 'Αριθμός Παραστατικού',
    'documentSeriesRemotedCode': 'Απομακρυσμένος Κωδικός Σειράς Παραστατικού',
    'documentType': 'Τύπος Παραστατικού',
    'documentTypeCode': 'Κωδικός Τύπου Παραστατικού',
    'documentTypeRemotedCode': 'Απομακρυσμένος Κωδικός Τύπου Παραστατικού',
    'documentTypes': 'Τύποι Παραστατικών',
    'editImport': 'Επεξεργασία Εισαγωγής',
    'entities': {
      'customer': 'Πελάτη',
      'documentType': 'Τύπου Παραστατικού',
      'materialAlterCode': 'Εναλλακτικού Κωδικού Είδους',
      'measurementUnit': 'Μονάδας Μέτρησης',
      'paymentType': 'Τύπου Πληρωμής',
      'representativeImport': 'Εισαγωγής Αντιπροσώπου',
      'traderSite': 'Υποκαταστήματος',
      'warehouse': 'Αποθήκης',
    },
    'erpName': 'Όνομα ERP',
    'exportFileNameFormat': 'Τύπος Αρχείου Εξαγωγής',
    'exportFolder': 'Φάκελος Εξαγωγής',
    'exportMethodType': 'Τύπος Εξαγωγής',
    'exportUrl': 'URL Εξαγωγής',
    'fieldMapping': {
      'addFieldMapping': 'Προσθήκη Field Mapping',
      'cacheResults': 'Cache Results',
      'cacheTimeout': 'Cache Timeout',
      'childFieldMappings': 'Child Field Mappings',
      'childMappingSettings': 'Child Mapping Settings',
      'childRecordType': 'Child Record Type',
      'dataType': 'Data Type',
      'defaultValue': 'Προεπιλγμένη Τιμή',
      'description': 'Περιγραφή',
      'editFieldMapping': 'Επεξεργασία Field Mapping',
      'isChildCollection': 'Is Child Collection',
      'isNullable': 'Is Nullable',
      'isRequired': 'Απαραίτητο',
      'keyField': 'Key Field',
      'lookupDescription': 'Lookup Description',
      'lookupEnabled': 'Lookup Enabled',
      'lookupTable': 'Lookup Table',
      'resultField': 'Result Field',
      'sourceField': 'Source Field',
      'targetField': 'Target Field',
      'toValidateEnabled': 'To_Validate Enabled',
      'toValidateLogTableName': 'To_Validate Log Table Name',
      'toValidateSourceField': 'To_Validate Source Field',
      // MappingField properties
      'csvColumnIndex': 'CSV Column Index',
      'csvColumnName': 'CSV Column Name',
      'databaseColumnName': 'Database Column Name',
      'fixedLengthLength': 'Length',
      'fixedLengthStartPosition': 'Start Position',
      'jsonPath': 'JSON Path',
      // ChildMappingSettings properties
      'childCsvDetailSeparator': 'Child CSV Detail Separator',
      'childCsvFieldSeparator': 'Child CSV Field Separator',
      'childCsvStartColumnIndex': 'Child CSV Start Column Index',
      'childDatabaseGroupBy': 'Group By',
      'childDatabaseJoinCondition': 'Join Condition',
      'childFixedLengthDetailRecordLength': 'Child Fixed Length Detail Record Length',
      'childFixedLengthMaxDetails': 'Child Fixed Length Max Details',
      'childFixedLengthStartPosition': 'Child Fixed Length Start Position',
      'childJsonArrayPath': 'Child JSON Array Path',
      'childJsonItemPath': 'Child JSON Item Path',
      'childRelationshipKey': 'Child Relationship Key',
      'childToKeyField': 'Child To Table Key Field',
      'childToTableName': 'Child To Table Name',
      'errors': {
        'parentMappingRequired':
          'You must first create a field mapping for "{parentProperty}" as a child collection before adding child properties.',
      },
      // FilterCondition properties
      'addNew': 'Add Field Mapping',
      'field': 'Field',
      'filterConditions': 'Filter Conditions',
      'operator': 'Operator',
      'rowMapping': 'Row Mappings',
      'value': 'Value',
    },
    'importFileNameFormat': 'Τύπος Αρχείου Εισαγωγής',
    'importFolder': 'Φάκελος Εισαγωγής',
    'importUrl': 'URL Εισαγωγής',
    'isApproved': 'Εγκεκριμένο',
    'isInvalid': 'Μη Έγκυρο',
    'isMapped': 'Αντιστοιχισμένα',
    'lastExportedDate': 'Τελευταία Εξαγωγή',
    'lastImportDate': 'Τελευταία Εισαγωγή',
    'mapping': 'Mapping Οντοτήτων',
    'materialAlterCodes': 'Κωδικοί Ειδών',
    'measurementUnits': 'Μονάδες Μέτρησης',
    'officialDate': 'Ημερομηνία Παραστατικού',
    'paymentTypeCode': 'Κωδικός Τρόπου Πληρωμής',
    'paymentTypeRemotedCode': 'Απομακρυσμένος Κωδικός Τρόπου Πληρωμής',
    'paymentTypes': 'Τύποι Πληρωμής',
    'properties': 'Ιδιότητες',
    'recipient': 'Παραλήπτης',
    'recipientAddress': 'Διεύθυνση Παραλήπτη',
    'recipientCity': 'Πόλη Παραλήπτη',
    'recipientCode': 'Κωδικός Παραλήπτη',
    'recipientName': 'Όνομα Παραλήπτη',
    'recipientRemotedAddress': 'Απομακρυσμένη Διεύθυνση Παραλήπτη',
    'recipientRemotedCity': 'Απομακρυσμένη Πόλη Παραλήπτη',
    'recipientRemotedCode': 'Απομακρυσμένος Κωδικός Παραλήπτη',
    'recipientRemotedName': 'Απομακρυσμένο Όνομα Παραλήπτη',
    'recipientRemotedTaxCode': 'Απομακρυσμένος ΑΦΜ Παραλήπτη',
    'recipientSiteAddress': 'Διεύθυνση Υποκαταστήματος Παραλήπτη',
    'recipientSiteCity': 'Πόλη Υποκαταστήματος Παραλήπτη',
    'recipientSiteCode': 'Κωδικός Υποκαταστήματος Παραλήπτη',
    'recipientSiteName': 'Όνομα Υποκαταστήματος Παραλήπτη',
    'recipientTaxCode': 'ΑΦΜ Παραλήπτη',
    'recordMapping': {
      'addNew': 'Προσθήκη Mapping',
      'allowCustomSeparators': 'Επιτρέπονται Custom Separators',
      'arrayPath': 'Array Path',
      'commandTimeout': 'Command Timeout',
      'concatenationDescription': 'Περιγραφή συνδυασμού',
      'concatenationSettings': 'Ρυθμίσεις concatenation',
      'connectionString': 'Connection String',
      'createdDate': 'Ημερομηνία Δημιουργίας',
      'defaultSeparator': 'Προπεπιλεγμένος Separator',
      'description': 'Περιγραφή',
      'editRecordMapping': 'Επεξεργασία Mapping',
      'encoding': 'Encoding',
      'importSettings': 'Ρυθμίσεις Import',
      'includeSeparatorInSource': 'Include Separator In Source',
      'mappingInfo': 'Πληροφορίες Mapping',
      'mappingType': 'Τύπος Mapping',
      'mappings': 'Mappings',
      'padCharacter': 'Pad Character',
      'query': 'Query',
      'quoteCharacter': 'Quote Character',
      'recordLength': 'Μήκος Record',
      'recordType': 'Record Type',
      'representative': 'Αντιπρόσωπος',
      'rootPath': 'Root Path',
      'selectRecordMappingToViewFields': 'Επιλέξτε Record Mapping για να δείτε τα διαθέσιμα πεδία',
      'separator': 'Separator',
      'skipFirstLine': 'Παρέβλεψε τις πρώτες γραμμές',
      'targetEntity': 'Target Entity',
      'validateSchema': 'Validate Schema',
      'viewRecordMapping': 'Προβολή Mapping',
    },
    'remarks': 'Σχόλια',
    'remotedCode': 'Κωδικός Αντιπροσώπου',
    'remotedCustomer': 'Αντιστίχοιση Πελάτη',
    'representative': 'Αντιπρόσωπος',
    'representativeDocumentSeriesCode': 'Κωδικός Σειράς',
    'representativeDocumentType': 'Τύπος Παραστατικού Αντιπροσώπου',
    'representativeDocumentTypeCode': 'Κωδικός Παραστατικού',
    'representativeInfo': 'Αντιπρόσωπος',
    'representativePaymentType': 'Τρόπος Πληρωμής Αντιπροσώπου',
    'representativeSite': 'Υποκατάστημα Αντιπροσώπου',
    'selectRepresentative': 'Επιλογή Αντιπροσώπου',
    'serverAddress': 'Διεύθυνση Server',
    'serverPort': 'Port Server',
    'setAsDefaultForAllCustomers': 'Ορισμός ως προεπιλογή για Όλους τους Πελάτες',
    'source': 'Πηγή',
    'status': 'Κατάσταση',
    'toApprove': 'Προς Έγκριση',
    'toExport': 'Προς Εξαγωγή',
    'traderSite': 'Υποκατάστημα',
    'traderSiteRemoteCode': 'Kωδικός Υποκαταστήματος',
    'traderSites': 'Υποκαταστήματα',
    'warehouseRemotedCode': 'Απομακρυσμένος Κωδικός Αποθήκης',
    'warehouses': 'Αποθήκες',
    'windowsAuthentication': 'Windows Authentication',
  },
  'routes': {
    'accountGroup': 'Account group',
    'addTraderSites': 'Προσθήκη Καταστημάτων',
    'allowWhenUnique': 'Μοναδικότητα',
    'companySite': 'Εταιρικό Κατάστημα',
    'customizeOrderText': 'Προσαρμόστε την σειρά επισκέψεων για κάθε ημέρα.',
    'customerCode': 'Κωδικός πελάτη',
    'customerProfession': 'Επάγγελμα πελάτη',
    'definition': 'Ορισμός Δρομολογίου',
    'reviewOrderText': 'Δείτε την σειρά επισκέψεων για κάθε ημέρα.',
    'route': 'Δρομολόγιο',
    'routeDefinition': 'Τύπος',
    'siteCode': 'Κωδικός καταστήματος',
    'typeOfRoute': 'Τύπος δρομολογίου',
    'typeOfSalesPerson': 'Τύπος πωλητή',
    'typeOfUser': 'Τύπος χρήστη',
    'user': 'Χρήστης',
    'viewWeekPlan': 'Εβδομαδιαίο πλάνο',
  },
  'taxNumber': 'ΑΦΜ',
  'telephone': 'Τηλέφωνο',
  'trader': {
    'adt': 'Αριθμός Δελτίου Ταυτότητας',
    'adtDate': 'Ημερομηνία Έκδοσης Δελτίου Ταυτότητας',
    'country': 'Χώρα',
    'county': 'Νομός',
    'doy': 'ΔΟΥ',
    'firstName': 'Όνομα',
    'job': 'Επάγγελμα',
    'lastName': 'Επώνυμο',
    'passport': 'Διαβατήριο',
    'passportExpireDate': 'Ημερομηνία Λήξης Διαβατηρίου',
    'socialNumber': 'ΑΜΚΑ',
    'taxOffice': 'ΔΟΥ',
    'title': 'Τίτλος',
    'traders': 'συναλλασσόμενοι',
    'vatStatus': 'Καθεστώς ΦΠΑ',
  },
  'traderSites': {
    'companySite': 'Εταιρικό κατάστημα',
    'latitude': 'Γεωγραφικό πλάτος',
    'longitude': 'Γεωγραφικό μήκος',
    'siteName': 'Όνομα καταστήματος',
    'storePhoto': 'Φωτογραφία καταστήματος',
    'traderName': 'Συναλλασσόμενος',
  },
  'transactions': {
    'companyAlterCode': 'Εναλλακτικός Κωδικός Εταιρείας',
    'companyUnit2': 'Μονάδα Εταιρείας 2',
    'companyUnit3': 'Μονάδα Εταιρείας 3',
    'customerSiteCode': 'Κωδικός Τοποθεσίας Πελάτη',
    'customerSiteName': 'Όνομα Τοποθεσίας Πελάτη',
    'discount1': 'Έκπτωση 1',
    'discount2': 'Έκπτωση 2',
    'discount3': 'Έκπτωση 3',
    'discount4': 'Έκπτωση 4',
    'discount5': 'Έκπτωση 5',
    'discount6': 'Έκπτωση 6',
    'discountValue1': 'Αξία Έκπτωσης 1',
    'discountValue2': 'Αξία Έκπτωσης 2',
    'discountValue3': 'Αξία Έκπτωσης 3',
    'discountValue4': 'Αξία Έκπτωσης 4',
    'discountValue5': 'Αξία Έκπτωσης 5',
    'discountValue6': 'Αξία Έκπτωσης 6',
    'documentNumber': 'Αριθμός Εγγράφου',
    'isFromManager': 'Από Διαχειριστή',
    'officialDate': 'Επίσημη Ημερομηνία',
    'remoteCode': 'Απομακρυσμένος Κωδικός',
    'repMaterialCode': 'Κωδικός Υλικού Αντιπροσώπου',
    'repMaterialName': 'Όνομα Υλικού Αντιπροσώπου',
    'repMeasurementUnit1': 'Μονάδα Μέτρησης Αντιπροσώπου 1',
    'repUnit2': 'Μονάδα Αντιπροσώπου 2',
    'repUnit3': 'Μονάδα Αντιπροσώπου 3',
    'repUnitCode1': 'Κωδικός Μονάδας Αντιπροσώπου 1',
    'repUnitCode2': 'Κωδικός Μονάδας Αντιπροσώπου 2',
    'repUnitCode3': 'Κωδικός Μονάδας Αντιπροσώπου 3',
    'representativeRecipientCode': 'Κωδικός Παραλήπτη Αντιπροσώπου',
    'representativeRecipientName': 'Όνομα Παραλήπτη Αντιπροσώπου',
    'totalDiscountValue': 'Συνολική Αξία Έκπτωσης',
    'vatValue': 'Αξία ΦΠΑ',
  },
  'tree': {
    'addChildNode': 'Δημιουργία παιδιού',
    'addNode': 'Προσθήκη κόμβου',
    'addRoot': 'Δημιουργία ρίζας',
    'deleteItem': 'Διαγραφή',
    'dropIntoRoot': 'Μεταφορά στη ρίζα',
    'duplicate': 'Δημιουργία αντίγραφου',
    'edit': 'Επεξεργασία',
    'fullCollapse': 'Απόκρυψη',
    'fullExpand': 'Εμφάνιση',
    'loadMore': 'Φόρτωση περισσότερων',
    'rename': 'Μετονομασία',
  },
  'salesAreas': {
    'salesArea': 'περιοχής πωλήσεων',
  },
  'salesDocuments': {
    'headers': {
      'billingAddress': 'Διεύθυνση Χρέωσης',
      'companySite': 'Υποκατάστημα Εταιρίας',
      'customer': 'Πελάτης',
      'date': 'Ημ. Εκδοσης',
      'defaultQuantity': 'Default Ποσότητα',
      'deliveryAddress': 'Διεύθυνση Παράδοσης',
      'deliveryDate': 'Ημ. Παράδοσης',
      'deliveryType': 'Τρόπος Παράδοσης',
      'description': 'Περιγραφή',
      'loadRange': 'Χρήση Δυναμικής Γκάμας',
      'mediator': 'Διαμεσολαβητής',
      'number': 'Αριθμός',
      'paymentType': 'Τρόπος πληρωμής',
      'salesPerson': 'Πωλητής',
      'series': 'Σειρά',
      'status': 'Κατάσταση',
      'totalCharges': 'Σύνολο Χρεώσεων',
      'totalDiscount': 'Συν. Εκπτωσης',
      'totalGross': 'Τελική Αξία',
      'traderSite': 'Υποκατάστημα Πελάτη',
      'type': 'Τύπος Εγγράφου',
      'warehouse': 'Αποθήκη',
    },
    'filters': {
      'byCustomer': 'Ανά Πελάτη',
      'byCustomerGroup': 'Ανά Ομάδα Πελατών',
      'bySalesPerson': 'Ανά Πωλητή',
      'byStatus': 'Ανά Κατάσταση',
      'byType': 'Ανά Τύπο',
      'dateFrom': 'Ημ/νία Από',
      'dateTo': 'Ημ/νία Έως',
    },
    'tabs': {
      'details': 'Λεπτομέρειες',
      'materials': 'Είδη',
      'netTotal': 'Αξία',
      'remarks': 'Σχόλια',
      'taxes': 'Κρατήσεις-Φόροι',
      'totals': 'Σύνολα',
    },
    'billingAddModalSelect': 'Επιλογή Διεύθυνσης Χρέωσης',
    'chargeValueType': 'Τύπος Εξόδου',
    'chargesTotals': 'Σύνολα Εξόδων-Κρατήσεων',
    'comments': 'Σχόλια',
    'currentPrice': 'Τρέχουσα Τιμή',
    'customerModalSelect': 'Επιλογή Πελάτη',
    'description': 'Περιγραφή',
    'discountPc': 'Έκπτωση %',
    'discountTotal': 'Συνολική έκπτωση',
    'discountValue': 'Έκπτωση €',
    'documentDiscount': 'Έκπτωση παραστατικού',
    'documentPreview': 'Προεπισκόπηση Παραστατικού',
    'exists': 'Σε απόθεμα',
    'expensesAndCharges': 'Κατηγορία',
    'faces': 'Πλευρές',
    'forPrinting': 'Για Εκτύπωση',
    'grossTotal': 'Τελικό Σύνολο',
    'grossValue': 'Τελικό ποσό',
    'havePromo': 'Σε Προσφορά',
    'lastCollectionDate': 'Ημ. Τελευταίας Τιμοληψίας',
    'lastDate': 'Προηγούμενη ημ/νια',
    'lastPrice': 'Προηγούμενη τιμή',
    'materialBalance': 'Απόθεμα Αποθήκης',
    'mediatorModalSelect': 'Επιλογή Διαμεσολαβητή',
    'missingDocumentLines': 'Προσθέστε τουλάχιστον ένα προιόν για να δημιουργήσετε το παραστατικό.',
    'missingDocumentSeries': 'Δεν υπάρχουν σειρές. Αδυναμία δημιουργίας παραστατικού.',
    'netTotal': 'Καθαρό σύνολο',
    'netTotalAfterDiscounts': 'Καθαρή αξία μετά εκπτώσεων',
    'netTotalBeforeDiscounts': 'Καθαρή αξία προ εκπτώσεων',
    'notExist': 'Εκτός Λίστας',
    'notExists': 'Εκτός Αποθέματος',
    'qty': 'Ποσότητα',
    'quantity': 'Ποσότητα',
    'rangeFail':
      'Η εφαρμογή της Δυναμικής Γκάμας απέτυχε. Βεβαιωθείτε ότι έχετε επιλέξει Τύπο Παραστατικού, Πελάτη και Διεύθυνση Καταστήματος.',
    'rangeFailDocNotFound': 'Η εφαρμογή της Δυναμικής Γκάμας απέτυχε. Δεν βρέθηκε το Παραστατικό.',
    'rangeSuccess':
      'Προστέθηκαν {linesNumber} γραμμές από τη γκάμα για τον Τύπο Παραστατικού {docType}, τον Πελάτη {customer} και το κατάστημα {traderSite}.',
    'recentTransactions': 'Πρόσφατες συναλλαγές',
    'reportPreview': 'Προεπισκόπηση Report',
    'saveLinesBeforeChangingSite':
      'Η αλλαγή Διεύθυνσης Χρέωσης μπορεί να προκαλέσει υπολογισμούς στις γραμμές. Αποθηκεύστε όλες τις γραμμές του παραστατικού.',
    'search': 'Αναζήτηση κωδικού ή περιγραφής',
    'shelf': 'Ράφι',
    'taxesTotal': 'Σύνολο φόρων',
    'total': 'Σύνολο',
    'totalDiscountValue': 'Σύνολο εκπτώσεων',
    'totalNetValue': 'Συνολική καθαρή αξία',
    'totalQuantity': 'Συνολική ποσότητα',
    'totalVat': 'Σύνολο ΦΠΑ',
    'traderSiteAddModalSelect': 'Επιλογή Διεύθυνσης Υποκαταστήματος Πελάτη',
    'unitDiscount': 'Έκπτωση €',
    'unitDiscountPercentage': 'Έκπτωση %',
    'unitPrice': 'Τιμή μονάδος',
    'value': 'Αξία/Ποσοστο',
    'vat': 'ΦΠΑ',
    'vatCategory': 'Κατηγορία ΦΠΑ',
    'vatFactor': 'Ποσοστό ΦΠΑ',
  },
  'salesperson': {
    'addAllModalSubText':
      'Η φόρμα θα αποθηκευτεί αυτόματα. Είστε βέβαιοι ότι θέλετε να συνεχίσετε;',
    'addAllModalText': 'Πρόκειται να προσθέσετε όλους τους πωλητές με τις παρακάτω τιμές',
    'code': 'Κωδικός',
    'companySite': 'Εταιρικό κατάστημα',
    'distributionCannels': 'Κανάλια Διανομής',
    'info': 'Στοιχεία',
    'maxAccessLevel': 'Μέγιστο επίπεδο πρόσβασης',
    'name': 'Όνομα',
    'onlineSearchLevelValue': 'Επίπεδο online αναζήτησης',
    'salesperson': 'Πωλητής',
    'salesPersonDC': 'Κανάλι Διανομής Πωλητή',
    'salespersonType': 'Τύπου πωλητή',
    'selectSite': 'Επιλέξτε κατάστημα',
    'sequence': 'Σειρά',
    'type': 'Τύπος',
    'user': 'Χρήστης',
    'userName': 'Όνομα Χρήστη',
    'viewHierarchy': 'Προβολή κατάταξης',
  },
  'distributionChannel': {
    'distributionChannel': 'Κανάλι Διανομής',
  },
  'series': {
    'automaticNumber': 'Αυτόματη Αρίθμηση',
    'cancelingSeries': 'Ακυρωτική Σειρά',
    'prefix': 'Πρόθεμα',
    'sequence': 'Σειρά',
    'suffix': 'Κατάληξη',
  },
  'settings': {
    'addModule': 'Προσθήκη module',
    'adminRoleOverwriteInfo':
      'Όταν επιλεγεί ο ρόλος Διαχειριστή, θα αντικαταστήσει όλους τους άλλους ρόλους.',
    'administrator': 'Administrator',
    'all': 'All',
    'app': 'Εφαρμογή',
    'apps': 'Εφαρμογές',
    'appsModules': 'Εφαρμογές & modules',
    'appsModulesDesc': 'Ενεργοποίηση modules ανά εφαρμογή',
    'collectionManagement': 'Διαχείριση collection',
    'companySiteList': 'Τοποθεσίες Εταιρίας',
    'configuration': 'Ρύθμιση',
    'desktopAccess': 'Πρόσβαση από υπολογιστή',
    'documentsManagement': 'Διαχείριση εγγράφων',
    'general': 'Γενικά',
    'generalReporting': 'Γενικές αναφορές',
    'inStore': 'Στο κατάστημα',
    'inventory': 'Απόθεμα',
    'logistics': 'Logistics',
    'managerReporting': 'Αναφορές διαχείρισης',
    'mobileAccess': 'Πρόσβαση από κινητό',
    'modules': 'Modules',
    'modulesDesc': 'Ενεργά modules που απαιτούν επίσκεψη.',
    'requiresVisits': 'Απαιτούν Επίσκεψη',
    'roleDetailInfo': 'Διαχειριση ρόλου και τα δικαιωματων ανά module.',
    'roles': 'Ρόλοι',
    'salesSupervision': 'Επίβλεψη πωλήσεων',
    'transactions': 'Κινήσεις',
    'userDetailInfo': 'Δημιουργήστε χρήστες και ορίστε roles και company sites.',
    'userLastName': 'Πλήρες όνομα',
    'workOffline': 'Εργασία Offline',
    'workOfflineDesc': 'Ενεργοποίηση εφαρμογων που μπορουν να χρησιμοποιούνται offline.',
    'xvan': 'Xvan',
  },
  'sidebar': {
    'documents': 'Παραστατικά',
    'favorites': 'Αγαπημένα',
    'general': 'Γενικά',
    'grouping': 'Grouping',
    'logistics': 'Logistics',
    'menu': 'Menu',
    'priceCollection': 'Τιμοληψία',
    'prices': 'Τιμοκατάλογοι',
    'questionnaires': 'Ερωτηματολόγια',
    'representatives': 'Αντιπρόσωποι',
    'reports': 'Reports',
    'routes': 'Δρομολόγια',
    'salesDocuments': 'Παραστατικά',
    'salesSupervision': 'Sales Supervision',
    'settings': 'Ρυθμίσεις',
    'traders': 'Συναλλασσόμενοι',
    'transactions': 'Κινήσεις',
    'warehouse': 'Αποθήκη',
    'xvan': 'Xvan',
  },
  'validationLogs': {
    'exported': 'Εξαγωγή',
    'tableName': 'Όνομα Πίνακα',
  },
  'vatCategory': 'Κατηγορία ΦΠΑ',
  'vatLevel': 'Επίπεδο ΦΠΑ',
  'visitPlans': {
    'codeRequired': 'Πρέπει να επιλέξετε τουλάχιστον μία ημέρα',
    'days': 'Ημέρες',
    'effectiveWeek': 'Εβδομάδα',
    'executed': 'Πραγματοποιήθηκε',
    'giveName': 'Δώστε όνομα στο πλάνο επίσκεψης.',
    'insertDays': 'Επιλεξτε τις ημέρες του πλάνου επίσκεψης.',
    'missed': 'Δεν πραγματοποιήθηκε',
    'name': 'Ονομα',
    'planned': 'Προγραμματισμένο',
    'remarks': 'Σχόλια',
    'selectAll': 'Επιλογή όλων',
    'visitDate': 'Ημ/νία Επίσκεψης',
    'visitPlan': 'Πλάνο επίσκεψης',
    'visitPlan2': 'πλάνου επίσκεψης',
    'visitPlans': 'Πλάνο επίσκεψης',
    'weeklyStep': 'Weekly step',
  },
  'warehouse': {
    'isLogistics': 'Logistics',
    'minQuantity': 'Ελάχιστη ποσότητα',
  },
  'zipCode': 'Τ.Κ.',
  'zipCodes': 'Τ.Κ.',
};
